import React from "react";

type ScriptOptions = {
	async?: boolean;
	defer?: boolean;
	type?: string;
};

const cachedScripts: string[] = [];

export function loadScript(scr: string, options: ScriptOptions = {}): Promise<void> {
	return new Promise((resolve, reject) => {
		if (cachedScripts.includes(scr)) {
			resolve();
		} else {
			cachedScripts.push(scr);

			const script = document.createElement("script");
			script.src = scr;
			script.async = options.async ?? true;
			script.defer = options.defer ?? true;
			script.type = options.type ?? "module";

			script.addEventListener("load", () => {
				resolve();
			});

			script.addEventListener("error", e => {
				const scriptIndex = cachedScripts.indexOf(scr);
				if (scriptIndex >= 0) cachedScripts.splice(scriptIndex, 1);
				script.remove();
				reject(e);
			});

			document.body.appendChild(script);
		}
	});
}

export default function useScript(src: string, options: ScriptOptions = {}): boolean {
	const [loaded, setLoaded] = React.useState(cachedScripts.includes(src));

	React.useEffect(() => {
		if (loaded) return;

		loadScript(src, options)
			.then(() => {
				setLoaded(true);
			})
			.catch(e => {
				throw e;
			});
	}, [src, options, loaded]);

	return loaded;
}
